import React, { useState, useContext, Fragment, useEffect, useRef } from "react"
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom"
import "./dashboard.css"
import { AuthContext } from "../../Context/AuthContext";
import { FaQuestionCircle } from "react-icons/fa";
import { RiMenu3Line } from "react-icons/ri";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg";
import { ReactComponent as CategoryIcon } from "../../Asset/category.svg";
import {ReactComponent as CharterRequestIcon} from "../../Asset/clipboard-text.svg";
import { ReactComponent as ShipIcon } from "../../Asset/ship.svg";
import { ReactComponent as HagglingIcon } from "../../Asset/arrow-swap-horizontal.svg";
import { ReactComponent as SettingsIcon } from "../../Asset/seetings.svg";
import { ReactComponent as NotificationIcon } from "../../Asset/notifications.svg";


const pageTitles = {
  "": "Overview",
  "myvessels": "Vessels",
  "charter-requests": "Charter Requests",
  "haggling": "Haggling",
  "updates": "Documents",
  "updatevpass": "Change Password",
  "profile_v": "Company information",
  "allpendingupdate": "Pending Updates",
  "notifications": "Notifications",
};

export default function Dashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { user, logout } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  // Handle click outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Get the current page key for title and active link
  const pathKey = location.pathname.split("/").pop() || "";
  const pageTitle = pageTitles[pathKey] || "Dashboard";

  // Sidebar link helper
  const isActive = (key) => (pathKey === key ? "active" : "");

  // User initial for avatar
  const userInitial = user?.email ? user.email.charAt(0).toUpperCase() : "U";
  // User initials for sidebar avatar (first two letters)
  
  // Handle navigation link click to close sidebar on mobile
  const handleNavLinkClick = () => {
    setSidebarOpen(false);
  };

  return (
    <Fragment>
      <div className="vatug-dashboard">
        {/* Mobile sidebar backdrop */}
        {sidebarOpen && (
          <div className="vatug-sidebar-backdrop" onClick={() => setSidebarOpen(false)} />
        )}

        {/* Sidebar */}
        <div className={`vatug-sidebar ${sidebarOpen ? "open" : ""}`}>
          <div className="vatug-sidebar-header">
            <div className="vatug-sidebar-header-logo" onClick={() => navigate("/dashboard")} style={{ cursor: "pointer" }}>
              <BlackVatugIcon />
            </div>
          </div>
          <nav className="vatug-sidebar-nav">
            <div className="vatug-sidebar-nav-items">
              <Link to="" className={`vatug-sidebar-nav-link ${isActive("")}`} onClick={handleNavLinkClick}> <CategoryIcon className="vatug-sidebar-nav-icon" /> Overview </Link>
              <Link to="myvessels" className={`vatug-sidebar-nav-link ${isActive("myvessels")}`} onClick={handleNavLinkClick}> <ShipIcon className="vatug-sidebar-nav-icon" /> Vessels </Link>
              <Link to="charter-requests" className={`vatug-sidebar-nav-link ${isActive("charter-requests")}`} onClick={handleNavLinkClick}> <CharterRequestIcon className="vatug-sidebar-nav-icon" /> Charter Requests </Link>
              <Link to="haggling" className={`vatug-sidebar-nav-link ${isActive("haggling")}`} onClick={handleNavLinkClick}> <HagglingIcon className="vatug-sidebar-nav-icon" /> Haggling </Link>
              <Link to="profile_v" className={`vatug-sidebar-nav-link ${isActive("profile_v")}`} onClick={handleNavLinkClick}> <SettingsIcon className="vatug-sidebar-nav-icon" /> Settings </Link>
            </div>
          </nav>
          <div className="vatug-sidebar-footer">
            <Link to="/help" className="vatug-sidebar-nav-link" onClick={handleNavLinkClick}> <FaQuestionCircle className="vatug-sidebar-nav-icon" /> Help </Link>
          </div>
        </div>

        {/* Main Content */}
        <div className="vatug-main-content">
          <header className="vatug-header">
            <div className="vatug-header-left">
              <button className="vatug-menu-button" onClick={() => setSidebarOpen(true)}>
                <RiMenu3Line size={24} />
              </button>
              <h1 className="vatug-page-title">{pageTitle}</h1>
            </div>
            <div className="vatug-header-right">
              <button className="vatug-notification-button">
                <NotificationIcon size={20} onClick={() => navigate("/dashboard/notifications")} />
              </button>
              <div className="vatug-user-avatar" onClick={() => setDropdownOpen((v) => !v)} ref={dropdownRef} style={{ cursor: "pointer", position: "relative" }}>
                <span className="vatug-user-avatar-text">{userInitial}</span>
                {dropdownOpen && (
                  <div className="vatug-profile-dropdown">
                    <div className="vatug-profile-dropdown-header">
                      <div className="user-name">{user?.username || "User"}</div>
                      <div className="user-email">{user?.email}</div>
                    </div>
                    <div className="vatug-profile-dropdown-item" onClick={() => { setDropdownOpen(false); navigate("/dashboard/profile_v"); }}>Profile</div>
                    <div className="vatug-profile-dropdown-item" onClick={() => { setDropdownOpen(false); navigate("/create_vessel"); }}>Upload Vessel</div>
                    <div className="vatug-profile-dropdown-item" onClick={() => { setDropdownOpen(false); navigate("/dashboard/myvessels"); }}>My Vessels</div>
                    <div className="vatug-profile-dropdown-item" onClick={() => { setDropdownOpen(false); navigate("/dashboard/vessel-history"); }}>Vessel Order History</div>
                    <div className="vatug-profile-dropdown-item" onClick={() => { setDropdownOpen(false); navigate("/dashboard/our_vessels"); }}>Chartering</div>
                    <button className="vatug-profile-dropdown-signout" onClick={() => { setDropdownOpen(false); logout(); navigate("/"); }}>Sign out</button>
                  </div>
                )}
              </div>
            </div>
          </header>

          <main className="vatug-main">
            <Outlet />
          </main>
        </div>
      </div>
    </Fragment>
  );
} 